module.exports = __webpack_public_path__ + "static/img/top_icon.5dc5288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top_icon.png
// module id = 253
// module chunks = 1